import {
  FORGOT_PASSWORD_FEATURE,
  REGISTRATION_FEATURE,
  isRemovedFeature,
} from '@/removableFeatures';
import { CLINIC_AUTH } from '@/store/modules/user';

/**
 * @description Список маршрутов для клиники.
 * @var {any[]}
 */
const clinicRoutes = [
  {
    component: () => import('@/views/ClinicPanel/AdvertisingChannelList.vue'),
    name: 'ClinicPanelAdvertisingChannelList',
    path: '/advertising-channels',
  },
  {
    component: () => import('@/views/ClinicPanel/AppointmentScheduleCabinets.vue'),
    name: 'ClinicPanelAppointmentScheduleCabinets',
    path: '/appointment-schedule/cabinets',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/AppointmentScheduleCabinetPeriod.vue'),
    name: 'ClinicPanelAppointmentScheduleCabinetPeriod',
    path: '/appointment-schedule/cabinets/:id',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/AppointmentScheduleCabinetMonth.vue'),
    name: 'ClinicPanelAppointmentScheduleCabinetMonth',
    path: '/appointment-schedule/cabinets/:id/month/:month',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/AppointmentScheduleEmployees.vue'),
    name: 'ClinicPanelAppointmentScheduleEmployees',
    path: '/appointment-schedule/employees',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/AppointmentScheduleEmployeePeriod.vue'),
    name: 'ClinicPanelAppointmentScheduleEmployeePeriod',
    path: '/appointment-schedule/employees/:id',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/AppointmentScheduleEmployeeMonth.vue'),
    name: 'ClinicPanelAppointmentScheduleEmployeeMonth',
    path: '/appointment-schedule/employees/:id/month/:month',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/AppointmentSettings.vue'),
    name: 'ClinicPanelAppointmentSettings',
    path: '/appointment-settings',
  },
  {
    component: () => import('@/views/ClinicPanel/CabinetList.vue'),
    name: 'ClinicPanelCabinetList',
    path: '/cabinets',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/CashboxList.vue'),
    name: 'ClinicPanelCashboxList',
    path: '/cashboxes',
  },
  {
    component: () => import('@/views/ClinicPanel/CallHistory.vue'),
    name: 'ClinicPanelCallHistory',
    path: '/call-history',
  },
  {
    component: () => import('@/views/ClinicPanel/CashboxOnlineCheckOrManual.vue'),
    name: 'ClinicPanelCashbox',
    path: '/cashbox',
  },
  {
    component: () => import('@/views/ClinicPanel/ChiefPhysicianVisitList.vue'),
    name: 'ClinicPanelChiefPhysicianVisitList',
    path: '/chief-physician/visits',
  },
  {
    component: () => import('@/views/ClinicPanel/ChiefPhysicianVisit.vue'),
    name: 'ClinicPanelChiefPhysicianVisit',
    path: '/chief-physician/visits/:id',
  },
  {
    component: () => import('@/views/ClinicPanel/CrmFunnels.vue'),
    name: 'ClinicPanelCrmFunnels',
    path: '/crm-funnels/:funnel?',
    props: (route) => ({ initialSelectedFunnel: route.params.funnel }),
  },
  {
    component: () => import('@/views/ClinicPanel/CrmDeal.vue'),
    name: 'ClinicPanelCrmDeal',
    path: '/crm-deal/:id',
  },
  {
    component: () => import('@/views/ClinicPanel/DiaryTemplateList.vue'),
    name: 'ClinicPanelDiaryTemplateList',
    path: '/diary-templates',
  },
  {
    component: () => import('@/views/ClinicPanel/DocumentGenerations.vue'),
    name: 'ClinicPanelDocumentGenerations',
    path: '/document-generations',
  },
  {
    component: () => import('@/views/ClinicPanel/EmployeeList.vue'),
    name: 'ClinicPanelEmployeeList',
    path: '/employees',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/FormEmployee.vue'),
    name: 'ClinicPanelFormCreateEmployee',
    path: '/employees/create',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/EmployeeActionHistories.vue'),
    name: 'ClinicPanelEmployeeActionHistories',
    path: '/action-history',
  },
  {
    component: () => import('@/views/ClinicPanel/EmployeeProfileBasic.vue'),
    name: 'ClinicPanelEmployeeProfileBasic',
    path: '/employees/:id/basic',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/EmployeeProfileAdmission.vue'),
    name: 'ClinicPanelEmployeeProfileAdmission',
    path: '/employees/:id/admission',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/EmployeeProfilePermissions.vue'),
    name: 'ClinicPanelEmployeeProfilePermissions',
    path: '/employees/:id/permissions',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/EmployeeProfileEgisz.vue'),
    name: 'ClinicPanelEmployeeProfileEgisz',
    path: '/employees/:id/egisz',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/EmployeeProfileWorkPlace.vue'),
    name: 'ClinicPanelEmployeeProfileWorkPlace',
    path: '/employees/:id/work-place',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/IntegrationList.vue'),
    name: 'ClinicPanelIntegrationList',
    path: '/integrations',
  },
  {
    component: () => import('@/views/ClinicPanel/Integration32top.vue'),
    name: 'ClinicPanelIntegration32top',
    path: '/integrations/32top',
  },
  {
    component: () => import('@/views/ClinicPanel/IntegrationMangoOffice.vue'),
    name: 'ClinicPanelIntegrationMangoOffice',
    path: '/integrations/mango-office',
  },
  {
    component: () => import('@/views/ClinicPanel/IntegrationProdoctorov.vue'),
    name: 'ClinicPanelIntegrationProdoctorov',
    path: '/integrations/prodoctorov',
  },
  {
    component: () => import('@/views/ClinicPanel/IntegrationUis.vue'),
    name: 'ClinicPanelIntegrationUis',
    path: '/integrations/uis',
  },
  {
    component: () => import('@/views/ClinicPanel/MedcardMerging.vue'),
    name: 'ClinicPanelMedcardMerging',
    path: '/medcard-merging',
  },
  {
    component: () => import('@/views/ClinicPanel/NotificationPlans.vue'),
    name: 'ClinicPanelNotificationPlans',
    path: '/notification-plans',
  },
  {
    component: () => import('@/views/ClinicPanel/NotificationList.vue'),
    name: 'ClinicPanelNotificationList',
    path: '/notifications',
  },
  {
    component: () => import('@/views/ClinicPanel/PatientList.vue'),
    name: 'ClinicPanelPatientList',
    path: '/patients',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/PatientProfileAnamnesis.vue'),
    name: 'ClinicPanelPatientAnamnesis',
    path: '/patients/:id/anamnesis',
  },
  {
    component: () => import('@/views/ClinicPanel/PatientProfileAppointments.vue'),
    name: 'ClinicPanelPatientAppointments',
    path: '/patients/:id/appointments',
  },
  {
    component: () => import('@/views/ClinicPanel/PatientProfileBasic.vue'),
    name: 'ClinicPanelPatientBasic',
    path: '/patients/:id/basic',
  },
  {
    component: () => import('@/views/ClinicPanel/PatientProfileDocuments.vue'),
    name: 'ClinicPanelPatientDocuments',
    path: '/patients/:id/documents',
  },
  {
    component: () => import('@/views/ClinicPanel/WarehouseProductList.vue'),
    name: 'ClinicPanelWarehouseProductList',
    path: '/products',
  },
  {
    component: () => import('@/views/ClinicPanel/WarehouseProductArrivalList.vue'),
    name: 'ClinicPanelWarehouseProductArrivalList',
    path: '/products-arrivals',
  },
  {
    component: () => import('@/views/ClinicPanel/WarehouseProductArrival.vue'),
    name: 'ClinicPanelWarehouseProductArrival',
    path: '/products-arrivals/:arrivalId',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/WarehouseProductUnitList.vue'),
    name: 'ClinicPanelWarehouseProductUnitList',
    path: '/products-units',
  },
  {
    component: () => import('@/views/ClinicPanel/WarehouseProductWriteOffList.vue'),
    name: 'ClinicPanelWarehouseProductWriteOffList',
    path: '/products-writeoff',
  },
  {
    component: () => import('@/views/ClinicPanel/WarehouseProductWriteOff.vue'),
    name: 'ClinicPanelWarehouseProductWriteOff',
    path: '/products-writeoff/:writeOffId',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/NdflCertificateCreation.vue'),
    name: 'ClinicPanelNdflCertificateCreation',
    path: '/patients/:id/ndf-certificates/create',
  },
  {
    component: () => import('@/views/ClinicPanel/NdflCertificate.vue'),
    name: 'ClinicPanelNdflCertificate',
    path: '/ndf-certificates/:id',
  },
  {
    component: () => import('@/views/ClinicPanel/PatientProfileInvoiceList.vue'),
    name: 'ClinicPanelPatientInvoiceList',
    path: '/patients/:id/invoices',
  },
  {
    component: () => import('@/views/ClinicPanel/PatientProfileInvoice.vue'),
    name: 'ClinicPanelPatientInvoice',
    path: '/patients/:id/invoices/:invoiceId',
  },
  {
    component: () => import('@/views/ClinicPanel/PatientProfilePlanList.vue'),
    name: 'ClinicPanelPatientPlanList',
    path: '/patients/:id/plans',
  },
  {
    component: () => import('@/views/ClinicPanel/PatientProfilePlan.vue'),
    name: 'ClinicPanelPatientPlan',
    path: '/patients/:id/plans/:planId',
  },
  {
    component: () => import('@/views/ClinicPanel/PatientProfileHealthQuestionnaire.vue'),
    name: 'ClinicPanelPatientHealthQuestionnaire',
    path: '/patients/:id/questionnaire',
  },
  {
    component: () => import('@/views/ClinicPanel/PatientProfileSnapshots.vue'),
    name: 'ClinicPanelPatientSnapshots',
    path: '/patients/:id/snapshots',
  },
  {
    component: () => import('@/views/ClinicPanel/PatientProfileVisits.vue'),
    name: 'ClinicPanelPatientVisits',
    path: '/patients/:id/visits',
    props: (route) => ({ patientId: Number(route.params.id) }),
  },
  {
    component: () => import('@/views/ClinicPanel/PatientProfileVisit.vue'),
    name: 'ClinicPanelPatientVisit',
    path: '/patients/:id/visits/:visitId',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/FormPatient.vue'),
    name: 'ClinicPanelFormCreatePatient',
    path: '/patients/create',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/EmployeePayroll.vue'),
    name: 'ClinicPanelEmployeePayroll',
    path: '/payroll',
  },
  {
    component: () => import('@/views/ClinicPanel/EmployeePayrollDetails.vue'),
    name: 'ClinicPanelEmployeePayrollDetails',
    path: '/payroll-calculations/:calculationId/employees/:employeeId',
    props: ({ params: { calculationId, employeeId } }) => ({
      calculationId,
      employeeId,
    }),
  },
  {
    component: () => import('@/views/ClinicPanel/EmployeePayrollSchema.vue'),
    name: 'ClinicPanelEmployeePayrollSchema',
    path: '/employees/:id/payroll-schemas',
    props: (route) => ({ employeeId: Number(route.params.id) }),
  },
  {
    component: () => import('@/views/ClinicPanel/ServicePriceList.vue'),
    name: 'ClinicPanelServicePriceList',
    path: '/price-list',
  },
  {
    component: () => import('@/views/ClinicPanel/UserProfile.vue'),
    name: 'ClinicPanelUserProfile',
    path: '/profile',
  },
  {
    component: () => import('@/views/ClinicPanel/RegistryNdflCertificateList.vue'),
    name: 'ClinicPanelRegistryNdflCertificateList',
    path: '/registry/ndf-certificates',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/ReportDashboard.vue'),
    name: 'ClinicPanelReportDashboard',
    path: '/report-dashboard',
  },
  {
    component: () => import('@/views/ClinicPanel/ReportDirectionsRevenue.vue'),
    name: 'ClinicPanelReportDirectionsRevenue',
    path: '/report-directions-revenue',
  },
  {
    component: () => import('@/views/ClinicPanel/ReportPatientReturnRate.vue'),
    name: 'ClinicPanelReportPatientReturnRate',
    path: '/report-patient-return-rate',
  },
  {
    component: () => import('@/views/ClinicPanel/ReportEmployees.vue'),
    name: 'ClinicPanelReportEmployees',
    path: '/report-employees',
  },
  {
    component: () => import('@/views/ClinicPanel/ReportEmployeesPayroll.vue'),
    name: 'ClinicPanelReportEmployeesPayroll',
    path: '/report-payroll',
  },
  {
    component: () => import('@/views/ClinicPanel/ReportEmployeesWorkload.vue'),
    name: 'ClinicPanelReportEmployeesWorkload',
    path: '/report-employees-workload',
  },
  {
    component: () => import('@/views/ClinicPanel/ReportPatientAttractingCost.vue'),
    name: 'ClinicPanelReportPatientAttractingCost',
    path: '/report-patient-attracting-cost',
  },
  {
    component: () => import('@/views/ClinicPanel/ReportTreatmentPlans.vue'),
    name: 'ClinicPanelReportTreatmentPlans',
    path: '/report-treatment-plans',
  },
  {
    component: () => import('@/views/ClinicPanel/ReportWarehouseProductBalances.vue'),
    name: 'ClinicPanelReportWarehouseProductBalances',
    path: '/warehouse-product-balances',
  },
  {
    component: () => import('@/views/ClinicPanel/ReportPatientsAdministrators.vue'),
    name: 'ClinicPanelReportPatientsAdministrators',
    path: '/reports/patients/administrators',
  },
  {
    component: () => import('@/views/ClinicPanel/ReportSalesServices.vue'),
    name: 'ClinicPanelReportSalesServices',
    path: '/reports/sales/services',
  },
  {
    component: () => import('@/views/ClinicPanel/ReportServicesDms.vue'),
    name: 'ClinicPanelReportServicesDms',
    path: '/reports/services-dms',
  },
  {
    component: () => import('@/views/ClinicPanel/ReportSalesSources.vue'),
    name: 'ClinicPanelReportSalesSources',
    path: '/reports/sales/sources',
  },
  {
    component: () => import('@/views/ClinicPanel/EmployeeRoleList.vue'),
    name: 'ClinicPanelEmployeeRoleList',
    path: '/roles',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/ClinicSettings.vue'),
    name: 'ClinicPanelSettings',
    path: '/settings',
  },
  {
    component: () => import('@/views/ClinicPanel/Tariffs.vue'),
    name: 'ClinicPanelTariffs',
    path: '/tariffs',
  },
  {
    component: () => import('@/views/ClinicPanel/TaskList.vue'),
    name: 'ClinicPanelTaskList',
    path: '/tasks',
  },
  {
    component: () => import('@/views/ClinicPanel/TreatmentPlanTemplateList.vue'),
    name: 'ClinicPanelTreatmentPlanTemplateList',
    path: '/treatment-plan-templates',
  },
  {
    component: () => import('@/views/ClinicPanel/ClinicDocumentTemplateList.vue'),
    name: 'ClinicPanelClinicDocumentTemplateList',
    path: '/document-templates',
  },
  {
    component: () => import('@/views/ClinicPanel/WarehouseVendorList.vue'),
    name: 'ClinicPanelWarehouseVendorList',
    path: '/vendors',
  },
  {
    component: () => import('@/views/ClinicPanel/WaitingList.vue'),
    name: 'ClinicPanelWaitingList',
    path: '/waiting-list',
  },
  {
    component: () => import('@/views/ClinicPanel/Welcome.vue'),
    name: 'ClinicPanelWelcome',
    path: '/welcome',
  },
  {
    component: () => import('@/views/ClinicPanel/WorkSchedule.vue'),
    name: 'ClinicPanelWorkSchedule',
    path: '/work-schedule',
    props: true,
  },
  {
    component: () => import('@/views/ClinicPanel/WorkTimeAccountJournal.vue'),
    name: 'ClinicPanelWorkTimeAccountJournal',
    path: '/work-time-account-journal',
  },
  {
    component: () => import('@/views/ClinicPanel/Help.vue'),
    name: 'ClinicPanelHelp',
    path: '/help',
  },
].map((route) => Object.assign(route, {
  meta: {
    authOf: CLINIC_AUTH,
    layout: 'clinic-panel-layout',
  },
}));

/**
 * @description Список общих маршрутов.
 * @var {any[]}
 */
const generalRoutes = [
  {
    path: '/',
    redirect: {
      name: 'Auth',
    },
  },
  {
    component: () => import('@/views/Activate.vue'),
    meta: {
      layout: 'entrance-layout',
    },
    name: 'Activate',
    path: '/activate/:id',
  },
  ...(isRemovedFeature(FORGOT_PASSWORD_FEATURE) ? [] : [{
    component: () => import('@/views/ForgotPassword.vue'),
    meta: {
      layout: 'entrance-layout',
    },
    name: 'ForgotPassword',
    path: '/forgot-password',
    props: true,
  }]),
  {
    component: () => import('@/views/Auth.vue'),
    name: 'Auth',
    meta: {
      layout: 'entrance-layout',
    },
    path: '/login',
    props: true,
  },
  {
    component: () => import('@/views/PrivacyPolicy.vue'),
    meta: {
      layout: 'empty-layout',
    },
    name: 'PrivacyPolicy',
    path: '/privacy-policy',
  },
  ...(isRemovedFeature(REGISTRATION_FEATURE) ? [] : [{
    component: () => import('@/views/Registration.vue'),
    meta: {
      layout: 'entrance-layout',
    },
    name: 'Registration',
    path: '/registration',
  }]),
  {
    component: () => import('@/views/ResetPassword.vue'),
    meta: {
      layout: 'entrance-layout',
    },
    name: 'ResetPassword',
    path: '/reset-password',
    props: (route) => ({ to: route.query.to }),
  },
];

export default [
  ...clinicRoutes,
  ...generalRoutes,
];
